import styled from '@emotion/styled'
import { useEffect, useRef } from 'react'

type imageVersions = 'placeholder' | 'medium' | 'mobile' | 'high'

interface Props {
   images: {
      [key in imageVersions]: string
   }
   className?: string
}

const LazyImage: React.FC<Props> = ({ images, className }) => {
   const imgRef = useRef(null)

   useEffect(() => {
      const img = imgRef.current as HTMLImageElement | null

      const loaded = () => {
         img?.classList.add('loaded')
         img?.classList.remove('loading')
      }
      if (img) {
         img.src = images.placeholder
         img.srcset = `${images.mobile} 300w, ${images.medium} 1920w, ${images.high} 2560w`
         img.sizes = `(max-width: 600px) 300px, (max-width: 1920px) 1920px, 2560px`
         img.loading = 'lazy'
         if (img.complete) {
            loaded()
         } else {
            img.addEventListener('load', loaded)
         }
      }
   }, [])

   return (
      <Holder style={{ backgroundImage: `url(${images.placeholder})` }} className={className}>
         <img ref={imgRef} />
      </Holder>
   )
}

const Holder = styled.div`
   position: relative;
   width: 100%;
   padding-top: 56.25%;
   background-size: cover;
   background-repeat: no-repeat;
   background-position: center center;

   img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: opacity 0.3s;
      opacity: 0;
      &.loaded {
         opacity: 1;
      }
   }
`

export default LazyImage
